import React from 'react';
import { IconProps } from './types';

export const AppleLogo = (props: IconProps) => {
  const { size = 20, color = 'currentColor', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 22 26'
    >
      <path
        fill={color}
        d='M18.42 13.827a5.957 5.957 0 012.814-4.958 6.123 6.123 0 00-4.765-2.576c-2.005-.21-3.949 1.2-4.97 1.2-1.042 0-2.615-1.18-4.309-1.144a6.398 6.398 0 00-5.34 3.257c-2.31 3.998-.587 9.873 1.625 13.105 1.106 1.582 2.4 3.35 4.092 3.287 1.656-.068 2.275-1.056 4.274-1.056 1.98 0 2.56 1.056 4.287 1.017 1.778-.03 2.897-1.59 3.965-3.187a13.088 13.088 0 001.813-3.693 5.76 5.76 0 01-3.485-5.252zM15.16 4.168A5.818 5.818 0 0016.49 0a5.919 5.919 0 00-3.83 1.982 5.586 5.586 0 00-1.366 4.013 4.952 4.952 0 003.865-1.827z'
      />
    </svg>
  );
};
